import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import {
  addTimeSheet,
  getTimeSheetMember,
  getTimeSheetTask,
} from '../../../redux/MainAction';
import { toast } from 'react-toastify';
import { FaClock, FaSave } from 'react-icons/fa';

const AddTimeSheetModal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const member = useSelector((state) => state?.Webtracker?.timesheetMember);
  const task = useSelector((state) => state?.Webtracker?.timesheetTask);

  const [addData, setAddData] = useState({
    employeeId: '',
    projectTaskId: '',
    startTime: '',
    endTime: '',
    description: '',
  });

  useEffect(() => {
    if (addData?.employeeId) {
      const data = {
        offset: 0,
        limit: 10,
        employeeId: addData?.employeeId,
      };
      dispatch(getTimeSheetTask(data));
    }
  }, [addData.employeeId]);

  // const getList = () => {
  //   const data = {
  //     offset: 0,
  //     limit: 100,
  //   };
  //   dispatch(getTimeSheetMember(data));
  // };

  const onHandleAddData = (e) => {
    const { name, value } = e.target;

    if (name === 'startTime' || name === 'endTime') {
      const isoValue = moment(value).toISOString();
      setAddData((prev) => ({
        ...prev,
        [name]: isoValue,
      }));
    } else {
      setAddData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const getLocalDatetime = (utcValue) => {
    if (!utcValue) return '';
    return moment(utcValue).local().format('YYYY-MM-DDTHH:mm');
  };

  const validateForm = () => {
    if (
      !addData.employeeId ||
      !addData.projectTaskId ||
      !addData.startTime ||
      !addData.endTime
    ) {
      toast.error('Please fill required fields And Date.', {
        position: 'top-right',
      });
      return false;
    }
    if (moment(addData?.startTime).isAfter(addData?.endTime)) {
      toast.error('Start time cannot be greater than end time', {
        position: 'top-right',
      });
      return false;
    }
    return true;
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const payload = {
      employeeId: addData.employeeId, // Required
      projectTaskId: addData.projectTaskId, // Required
      startTime: addData.startTime, // Required
      endTime: addData.endTime, // Required
      description: addData.description || '', // Optional
    };

    console.log('Payload:', payload);

    // Uncomment to dispatch the action
    dispatch(addTimeSheet(payload));

    onClose();
    setAddData({
      employeeId: '',
      projectTaskId: '',
      startTime: '',
      endTime: '',
      description: '',
    });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal2' }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h5 style={{ color: 'rgba(13, 71, 161, 0.8)' }}>
          Add Timesheet <FaClock />
        </h5>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>

      <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
        <li className="nav-item">
          <a
            className="nav-link active"
            data-toggle="tab"
            href="#add_time"
            role="tab"
          >
            <span className="d-none d-md-block">Add Time</span>
            <span className="d-block d-md-none">
              <i className="mdi mdi-home-variant h5"></i>
            </span>
          </a>
        </li>
      </ul>

      <div className="tab-content timesheet-modal m-auto">
        <div className="tab-pane active p-2" id="add_time" role="tabpanel">
          <div className="d-flex flex-column" style={{ gap: '20px' }}>
            <select
              className="form-control"
              name="employeeId"
              value={addData?.employeeId}
              onChange={onHandleAddData}
            >
              <option>Select Employee (required)</option>
              {member?.rows?.map((emp, idx) => (
                <option key={idx} value={emp?.employeeId}>
                  {emp?.user?.firstName} {emp?.user?.lastName}
                </option>
              ))}
            </select>

            <select
              className="form-control"
              name="projectTaskId"
              value={addData?.projectTaskId}
              onChange={onHandleAddData}
            >
              <option>Select Project Task (required)</option>
              {task?.rows?.map((tsk, idx) => (
                <option key={idx} value={tsk?.id}>
                  {tsk?.name}
                </option>
              ))}
            </select>

            <div className="d-flex align-items-center" style={{ gap: '10px' }}>
              <input
                type="datetime-local"
                className="form-control"
                name="startTime"
                value={getLocalDatetime(addData?.startTime)}
                onChange={onHandleAddData}
              />
              <i className="dripicons-clock"></i>
              <input
                type="datetime-local"
                className="form-control"
                name="endTime"
                value={getLocalDatetime(addData?.endTime)}
                onChange={onHandleAddData}
              />
            </div>

            <textarea
              className="form-control"
              placeholder="Description (optional)"
              name="description"
              value={addData?.description}
              onChange={onHandleAddData}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="modal-footer d-flex justify-content-center align-items-center mt-2">
        <button
          type="button"
          className="btn btn-primary d-flex align-items-center"
          onClick={onSubmit}
        >
          <FaSave className="mr-1" /> Save
        </button>
      </div>
    </Modal>
  );
};

export default AddTimeSheetModal;
